import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

/**
 * 查询 kp members list
 * @param {*} s
 */
export const queryMemberList = params => {
    return request({
        url: requestUrl('/site/member/page'),
        method: 'post',
        data: requestParam(params)
    });
};

export const checkLoginUserHasRoles = params => {
    return request({
        url: requestUrl(`/site/checkLoginUserHasRoles/${params}`),
        method: 'post'
    });
}

/**
 * change kp members is contact
 * @param {*} s
 */
export const kpIsContact = params => {
    return request({
        url: requestUrl('/site/member/contact'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * change component members
 * @param {*} s
 */
export const changeKpMember = params => {
    return request({
        url: requestUrl('/site/member/kpMember'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 删除 clientUser
 * @param {*} s
 */
export const deleteMembers = params => {
    return request({
        url: requestUrl('/site/member/delete'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 新增 clientUser
 * @param {*} s
 */
export const bindMembers = params => {
    return request({
        url: requestUrl('/site/member/bind'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * updateSiteOwner
 * @param {*} s
 */
export const updateSiteOwner = params => {
    return request({
        url: requestUrl('/site/member/updateSiteOwner'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * updateSiteManager
 * @param {*} s
 */
export const updateSiteManager = params => {
    return request({
        url: requestUrl('/site/member/updateSiteManager'),
        method: 'post',
        data: requestParam(params)
    });
};
/**
 * updateSiteManager
 * @param {*} s
 */
export const updateSiteAdmin = params => {
    return request({
        url: requestUrl('/site/member/updateSiteAdmin'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * querySiteInfo
 * @param {*} s
 */
export const querySiteInfo = params => {
    return request({
        url: requestUrl('/site/member/querySiteInfo'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * updateKPMemberRole
 * @param {*} s
 */
export const updateKPMemberRole = params => {
    return request({
        url: requestUrl('/site/member/updateKPMemberRole'),
        method: 'post',
        data: requestParam(params)
    });
};
/**
 * updateMemberRole
 * @param {*} s
 */
export const updateMemberRole = params => {
    return request({
        url: requestUrl('/manage/clientUser/update/role'),
        method: 'post',
        data: requestParam(params)
    });
};

export const downloadKPMembersTemplate = params => {
    return request({
        url: requestUrl('/site/downloadKPMembersTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    });
};

export const importKPMembers = params => {
    return request({
        url: requestUrl('/site/importKPMembers'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
};
